import { useEffect } from 'react';

/**
 * This hook takes in array of React DOM refs and a callback function to execute
 * when user clicks anywhere outside of the provided DOM refs
 * @param {array} refs - Array of React DOM refs that we don't want the callback function
 * to be triggered on
 * @param {function} callback - Callback function to execute when user clicks outside of
 * provided DOM refs
*/
export const useOnClickOutside = (refs, handler) => {
  useEffect(() => {
    const listener = (event) => {
      const isOutside = Array.isArray(refs)
        && refs.length > 0
        && refs
          .filter((ref) => !!ref?.current)
          .every((ref) => ref.current && !ref.current.contains(event.target));

      if (isOutside) {
        handler(event);
      }
    };

    // NOTE:
    // Do not add "click" event listener as it causes event bubbling when a focus area contains
    // existing click handlers

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    document.addEventListener('focusin', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
      document.removeEventListener('focusin', listener);
    };
  }, [handler, refs]);
};
